<div class="popup-dialog" [attr.data-testid]="popupId">
    <!-- Start Title Bar -->
    <div class="popup-dialog__top">
        <h2 class="h3">{{ getDictionaryItem("addCase") }}</h2>
        <button
            mat-icon-button
            [attr.data-testid]="'close-create-case-dialog-button'"
            (click)="closeVaultDialog()"
            class="popup-dialog__button"
            aria-label="Luk dialog"
            role="button"
            type="button"
        >
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
    @if (isSubmitting) {
        <div class="loading-wrapper">
            <mat-spinner class="loading"></mat-spinner>
        </div>
    }
    <form class="mat-form" (ngSubmit)="onSubmit()" [formGroup]="caseForm" [attr.data-testid]="popupForm">
        @if (userAccounts.length > 0) {
            <mat-form-field class="mb-4" data-testid="form-field-1" [attr.disabled]="userAccounts.length === 1 ? true : false">
                <mat-label> {{ getDictionaryItem("selectWorks") }} </mat-label>
                <mat-select name="account" formControlName="account" [attr.tabindex]="userAccounts.length === 1 ? -1 : 0">
                    @for (account of userAccounts; track account.contactid; let index = $index) {
                        <mat-option [value]="account.parentcustomerid_account.accountid" [id]="'mat-option-' + index">{{
                            account.parentcustomerid_account.name
                        }}</mat-option>
                    }
                </mat-select>
                @if (caseForm.get("account")?.hasError("required")) {
                    <mat-error> {{ getDictionaryItem("selectWorks") }} {{ getDictionaryItem("isRequired") }}. </mat-error>
                }
            </mat-form-field>
        }

        <mat-form-field class="mb-4" data-testid="form-field-2" [attr.disabled]="false">
            <mat-label> {{ getDictionaryItem("selectArea") }} </mat-label>
            <mat-select name="businessArea" formControlName="businessArea" (selectionChange)="businessAreasEvent()">
                @for (area of businessAreas; track area.id; let index = $index) {
                    <mat-option [value]="area.id" [id]="'mat-option-' + index">{{ area.name }}</mat-option>
                }
            </mat-select>
            @if (caseForm.get("businessArea")?.hasError("required")) {
                <mat-error> {{ getDictionaryItem("selectArea") }} {{ getDictionaryItem("isRequired") }}. </mat-error>
            }
        </mat-form-field>

        <mat-form-field
            class="mb-4"
            [class]="caseForm.get('businessArea')?.value === '' ? 'disabled-field' : ''"
            data-testid="form-field-3"
            [attr.disabled]="caseForm.get('businessArea')?.value === '' ? true : false"
        >
            <mat-label> {{ getDictionaryItem("selectCategory") }} </mat-label>
            <mat-select id="category-select-field" name="category" formControlName="category" [attr.tabindex]="caseForm.get('businessArea')?.value === '' ? -1 : 0">
                @for (cat of categories; track cat.categoryId; let index = $index) {
                    <mat-option [value]="cat.categoryId" [id]="'mat-option-' + index">{{ cat.name }}</mat-option>
                }
            </mat-select>
            @if (caseForm.get("category")?.hasError("required")) {
                <mat-error> {{ getDictionaryItem("selectCategory") }} {{ getDictionaryItem("isRequired") }}. </mat-error>
            }
        </mat-form-field>

        <mat-form-field class="mb-4" data-testid="form-field-4">
            <mat-label> {{ getDictionaryItem("headline") }} </mat-label>
            <input type="text" matInput formControlName="title" />
            @if (caseForm.get("title")?.hasError("minlength")) {
                <mat-error> {{ getDictionaryItem("headline") }} {{ getDictionaryItem("caseTextErrorMessage") }}. </mat-error>
            }
        </mat-form-field>

        <span class="h4 mb-4" id="plan-date-label">Ønsker du kontakt på et bestemt tidspunkt, eller skal opgaven udsættes? Angiv tidspunkt.</span>
        <div class="plan-date" role="region" aria-labelledby="plan-date-label">
            <mat-form-field class="mb-4" data-testid="form-field-5">
                <mat-label id="oprettelsesdato-label">Dato</mat-label>
                <input
                    matInput
                    [matDatepicker]="picker"
                    formControlName="createdDate"
                    aria-labelledby="oprettelsesdato-label"
                    aria-describedby="plan-date-label"
                    placeholder="Vælg dato"
                    [min]="today"
                />
                <mat-datepicker-toggle matSuffix [for]="picker" [attr.aria-label]="'Åben datovælger'"></mat-datepicker-toggle>
                <mat-datepicker #picker>
                    <mat-datepicker-actions>
                        <button mat-button matButton="elevated" matDatepickerCancel [attr.aria-label]="'Ryd dato filter'" type="button" (click)="clearDateOption()">
                            Fjern dato
                        </button>
                        <button mat-button matButton="elevated" matDatepickerApply [attr.aria-label]="'Tilføj dato filter'" type="button">Tilføj dato</button>
                    </mat-datepicker-actions>
                </mat-datepicker>
            </mat-form-field>

            @if (caseForm.get("createdDate")?.value) {
                <mat-form-field class="mb-4" data-testid="form-field-6">
                    <mat-label id="oprettelsestid-label">Tidspunkt</mat-label>
                    <mat-select formControlName="createdTime" aria-labelledby="oprettelsestid-label" aria-describedby="plan-date-label" placeholder="Vælg tid">
                        @for (time of timeOptions; track time; let index = $index) {
                            <mat-option [value]="time" [id]="'mat-option-' + index">
                                {{ time }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }
        </div>

        <p class="team-text">
            Er din teamviewer kørende? ellers kan du hente den her:
            <a [href]="'https://get.teamviewer.com/softvaerket'" class="teamviewer-link" title="Åben Teamviewer" target="_blank" rel="noopener noreferrer">
                <span class="sr-only">{{ getDictionaryItem("openTeamViewer") }}</span>
                <img [src]="'./assets/images/teamviewer_icon.svg'" alt="Teamviewer Logo" />
            </a>
        </p>
        <mat-form-field>
            <mat-label id="textarea"> {{ getDictionaryItem("description") }} </mat-label>
            <textarea
                matInput
                formControlName="description"
                [attr.aria-labelledby]="'textarea'"
                (paste)="pasteFilesToImageGallery($event)"
                data-testid="form-field-7"
            ></textarea>
            @if (caseForm.get("description")?.hasError("minlength")) {
                <mat-error> {{ getDictionaryItem("description") }} {{ getDictionaryItem("caseTextErrorMessage") }}. </mat-error>
            }
        </mat-form-field>

        <app-image-gallery #imageGallery (imageGallery)="eventHandler($event)" [isDisabled]="isSubmitting"></app-image-gallery>

        <button type="submit" mat-button class="cta-button" [attr.data-testid]="submitButton" [disabled]="caseForm.invalid || isSubmitting">
            <span> {{ getDictionaryItem("addCase").toLocaleUpperCase() }} </span>
        </button>
    </form>

    @if (showCloseWarning) {
        <div
            role="dialog"
            aria-labelledby="popup-dialog-warning-dialog-headline"
            id="popup-dialog-warning-dialog"
            class="popup-dialog__warning-dialog"
            [attr.data-testid]="popupWarning"
            cdkTrapFocus
            [cdkTrapFocusAutoCapture]="true"
        >
            <div class="popup-dialog__warning-dialog-content">
                <span class="text-default" id="popup-dialog-warning-dialog-headline">{{ getDictionaryItem("closeCaseWarningText") }} </span>
                <button mat-button [attr.data-testid]="'close-create-case-dialog-nej'" (click)="this.showCloseWarning = false">Nej</button>
                <button mat-button class="cta-button" [attr.data-testid]="'close-create-case-dialog-ja'" (click)="this.dialogRef.close()">Ja</button>
            </div>
        </div>
    }
</div>

@if (showMessageCenter) {
    <app-message-center [data]="messageCenter" [state]="messageCenterState" [progressCount]="5000" [isFixed]="true"></app-message-center>
}

@if (messagePopup.show && messagePopup.content !== undefined) {
    <div
        role="dialog"
        id="message-popup-dialog"
        class="popup-dialog__warning-dialog"
        [attr.data-testid]="popupWarning"
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
        aria-labelledby="message-popup-title"
        aria-describedby="message-popup-content"
    >
        <div class="popup-dialog__warning-dialog-content">
            <h2 class="h3" id="message-popup-title">{{ messagePopup.content.title }}</h2>
            <div class="text-default" id="message-popup-content" [innerHTML]="messagePopup.content.message"></div>
            <button mat-button class="cta-button" id="message-popup-close-button" (click)="this.messagePopup.show = false">
                {{ getDictionaryItem("closeMessage") }}
            </button>
        </div>
    </div>
}
